@if (apiForm) {
  <div #formContainer class="form-container" id="form-container">
    <form [formGroup]="apiForm">
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Parameters
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <clickatell-form-validation [controlName]="'name'" [form]="apiForm"></clickatell-form-validation>
            <input class="control-input"
              activeForm [activeForm]="apiForm"
              id="name"
              [formControlName]="'name'"
              placeholder="Enter a name"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Description </label>
              </div>
              <clickatell-form-validation [controlName]="'description'"
              [form]="apiForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="apiForm" id="description"
                [formControlName]="'description'" placeholder="Enter description"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> API Name </label>
                </div>
                <clickatell-form-validation [controlName]="'apiName'"
                [form]="apiForm"></clickatell-form-validation>
                <div>
                  <input type="text"
                    id="apiName"
                    #apiName
                    placeholder="Search or select an Api"
                    class="control-select"
                    matInput
                    (input)="apiInput(apiName.value)"
                    [matAutocomplete]="auto"
                    [activeForm]="apiForm"
                    [formControlName]="'apiName'">
                  </div>
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="apiSelected(apiName.value)" hideSingleSelectionIndicator>
                    @for (apiDetailName of apiDetailNamesFilter; track apiDetailName) {
                      <mat-option
                        [value]="apiDetailName">
                        {{ apiDetailName }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </div>
              </ng-container>
            </clickatell-expansion-panel>
            <clickatell-expansion-panel>
              <ng-container header>
                <mat-panel-title>
                  API Details
                </mat-panel-title>
              </ng-container>
              <ng-container body>
                @if (!hasLoading && apiForm.touched) {
                  <ng-container
                    *ngTemplateOutlet="apiDetailsBanner; context: { message: 'Waiting for Api details', type: 'error'}">
                  </ng-container>
                }
                @if (apiDetails$ | async) {
                  @if (apiDetails[apiName.value]) {
                    @if (apiDetails && apiName.value) {
                      <div class="apiDetails-container">
                        @for (key of API_DETAILS_DISPLAY; track key) {
                          <div class="apiDetails-container-items">
                            @if (apiDetails[apiName.value][key]) {
                              <div class="control-label"> {{ key }} : {{ apiDetails[apiName.value][key] }}</div>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (apiDetails[apiName.value]['method'] === 'POST' || apiDetails[apiName.value]['method'] === 'PUT') {
                      @if (apiDetails[apiName.value]['requestType'] === 'multipart/form-data') {
                        <div class="control-add-button apiDetails">
                          <button [disabled]="!canEdit" (click)="addKeyValue('body')">
                            Add New Form Data
                          </button>
                        </div>
                        <ng-container
                          *ngTemplateOutlet="keyValue; context: { controlName: 'body', label: 'Form Data'}">
                        </ng-container>
                      } @else {
                        <div class="control-div">
                          <div class="control-label-container">
                            <label class="control-label"> Body </label>
                          </div>
                          <clickatell-form-validation [controlName]="'body'"
                          [form]="apiForm"></clickatell-form-validation>
                          <textarea class="control-textArea" activeForm [activeForm]="apiForm" id="bodyString"
                            [formControlName]="'body'"
                          placeholder="Enter a body"></textarea>
                        </div>
                      }
                    }
                    <div class="control-add-button apiDetails">
                      <button [disabled]="!canEdit" (click)="addKeyValue('headers')">
                        Add New Header
                      </button>
                    </div>
                    @if (apiDetails && apiDetails[apiName.value] && apiDetails[apiName.value]['headers'] && !apiDetails[apiName.value]['headers'].length) {
                      @for (header of apiDetails[apiName.value]['headers'] | keyvalue; track header) {
                        <div class="control-result">
                          <div class="control-result-header">
                            Header
                          </div>
                          <div class="control-result-container">
                            <div class="control-div">
                              <input class="control-input" [id]="'api-header' + header.key"
                                [disabled]="true" [value]="header.key"/>
                              </div>
                              <div class="control-div">
                                <input class="control-input" [id]="'api-header' + header.value"
                                  [disabled]="true" [value]="header.value"/>
                                </div>
                              </div>
                            </div>
                          }
                        }
                        <ng-container *ngTemplateOutlet="keyValue; context: { controlName: 'headers', label: 'Header'}">
                        </ng-container>
                        <div class="control-add-button apiDetails">
                          <button [disabled]="!canEdit" (click)="addKeyValue('queryStrings')">
                            Add New Query Parameters
                          </button>
                        </div>
                        <ng-container
                          *ngTemplateOutlet="keyValue; context: { controlName: 'queryStrings', label: 'Query Parameters'}">
                        </ng-container>
                      } @else {
                        <ng-container
                          *ngTemplateOutlet="apiDetailsBanner; context: { message: 'Please select an API', type: 'warn'}">
                        </ng-container>
                      }
                    } @else {
                      <loading-icon class="align-loading"></loading-icon>
                    }
                  </ng-container>
                </clickatell-expansion-panel>
                <clickatell-expansion-panel>
                  <ng-container header>
                    <mat-panel-title>
                      Logic
                    </mat-panel-title>
                  </ng-container>
                  <ng-container body>
                    <ng-container>
                      <div class="control-add-button" (click)="addResult()">
                        <button [disabled]="!canEdit">
                          Add New Result
                        </button>
                      </div>
                      @for (result of apiForm.controls.result.controls; track result; let i = $index) {
                        <div class="control-result" [formGroup]="result">
                          <div class="control-result-header">
                            @if (result.controls.key.value) {
                              {{ result.controls.key.value }}
                            } @else {
                              <span class="control-result-defaultTitle">
                                [Result Name]
                              </span>
                            }
                            @if (result.controls.key.status !== 'DISABLED') {
                              <button class="control-result-delete"
                                (click)="deleteKeyValue('result', i)">
                                <img class="control-result-delete-btn" src="./assets/svg/redesign/trash.svg">
                              </button>
                            }
                          </div>
                          <div class="control-result-container">
                            @if (result.controls.key.status !== 'DISABLED') {
                              <div class="control-div">
                                <div class="control-label-container">
                                  <label class="control-label"> Result </label>
                                </div>
                                <clickatell-form-validation [controlName]="'key'"
                                [form]="result"></clickatell-form-validation>
                                <input class="control-input" activeForm [activeForm]="result" [id]="'Result-' + i"
                                  [formControlName]="'key'" placeholder="Enter a name"/>
                                </div>
                              }
                              <div class="control-div">
                                <label class="control-label">
                                  <span class="pont-to">Point To</span>
                                  <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                                </label>
                                @if (nodeFlowDetails) {
                                  <next-selector [canEditFlows]="canEdit.canEditFlows"
                                    [selectorType]="'both'"
                                    [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                    [flows]="nodeFlowDetails.flows"
                                    [name]="'value'"
                                    [form]="result"
                                    [stepId]="nodeFlowDetails.stepId">
                                  </next-selector>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </ng-container>
                    </ng-container>
                  </clickatell-expansion-panel>
                </form>
              </div>
            }


            <ng-template #keyValue let-controlName="controlName" let-label="label">
              @if (apiForm.controls[controlName] && controlName) {
                @for (control of apiForm.controls[controlName].controls; track control; let i = $index) {
                  <div class="control-result" [formGroup]="control">
                    <div class="control-result-header">
                      {{ label }}
                      @if (control.controls.key.status !== 'DISABLED') {
                        <button class="control-result-delete"
                          (click)="deleteKeyValue(controlName, i)">
                          <img class="control-result-delete-btn" src="./assets/svg/redesign/trash.svg">
                        </button>
                      }
                    </div>
                    <div class="control-result-container">
                      <div class="control-div">
                        <input class="control-input" activeForm [activeForm]="control" [id]="controlName + '-key-' + i"
                          [formControlName]="'key'" placeholder="Key"/>
                        </div>
                        <div class="control-div">
                          <input class="control-input" activeForm [activeForm]="control"
                            [id]="controlName + '-value-' + i"
                            [formControlName]="'value'" placeholder="value"/>
                          </div>
                        </div>
                      </div>
                    }
                    @if (apiForm.controls[controlName].controls.length >= 3) {
                      <div
                        class="control-add-button apiDetails">
                        <div class="control-label-add-btn" (click)="addKeyValue(controlName)">
                          <span class="control-label-add-btn-icon">
                            <img class="action-img" src='./assets/svg/addIcon.svg'/>
                          </span>
                          <span class="control-label-add-btn-label"> Add New {{ label }} </span>
                        </div>
                      </div>
                    }
                  }
                </ng-template>


                <ng-template #apiDetailsBanner let-message="message" let-type="type">
                  <div class="banner-container">
                    <div [ngClass]="['banner-block', 'banner-' + type + '-block']">
                      <div [ngClass]="['icon', 'icon-' + type]"></div>
                      <div class="content">
                        {{ message }}
                      </div>
                    </div>
                  </div>
                </ng-template>